<span id="{{id}}-header" class="screen-reader-content">{{t srHeader}}</span>
<ul class="sortable-list {{sortable_class}}" aria-labelledby="{{id}}-header">
  {{#each sortables}}
    <li class="{{id}} sortable {{class}}" id="{{id}}" tabindex="0" role="button" draggable="true" aria-describedby="srInstructions" aria-labelledby="{{#with header}}sortable-header-{{../id}}{{/with}} {{#with description}}sortable-description-{{../id}}{{/with}}">
      {{#with header}}<div id="sortable-header-{{../id}}" class="header{{#if class}} {{class}}{{/if}}">{{t text}}</div>{{/with}}
      {{#with description}}<div id="sortable-description-{{../id}}" class="description{{#if class}} {{class}}{{/if}}">{{t text}}</div>{{/with}}
      {{#if blocks}}<div data-region="{{../cid}}-sortables-{{@index}}-blocks"></div>{{/if}}
    </li>
  {{/each}}
</ul>

<div id="srInstructions" class="srInstructions screen-reader-content">{{t instructions}}</div>
<div class="srText screen-reader-content" aria-live="assertive"></div>
